var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.367,
    y1: 0.388,
    x2: 0.796,
    y2: 0.953,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa840e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d4207"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_star_24px",
    d: "M32,47.81,50.54,59,45.62,37.91,62,23.72,40.43,21.89,32,2,23.57,21.89,2,23.72,18.38,37.91,13.46,59Z",
    transform: "translate(-2 -2)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfill);
export default __webpack_public_path__ + "static/media/Starfill.0d46fc403a3526ccedc6ace7178ae8b8.svg";
export { ForwardRef as ReactComponent };